import * as React from "react";
import {
    DialogTitle as MuiDialogTitle,
    makeStyles,
    createStyles,
} from "@material-ui/core";
import classnames from "classnames";

import { DialogCloseIconButton, RelodeTheme, Text } from "..";
import { useDeviceSize } from "../hooks";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
            },
            draggable: {
                cursor: "move",
            },
        }),
    { name: "DialogTitle" }
);

export type DialogTitleProps = {
    title: React.ReactNode;
    onClose?: () => void;
};

export const DialogTitle = (props: DialogTitleProps) => {
    const { title, onClose } = props;
    const classes = useStyles(props);
    const device = useDeviceSize();
    const titleClasses = classnames(classes.root, {
        [classes.draggable]: device === "desktop",
    });

    let dataCy;

    if (props["data-cy"]) {
        dataCy = props["data-cy"];
    } else {
        dataCy = "dialog-title";
    }

    return (
        <MuiDialogTitle
            disableTypography={true}
            className={titleClasses}
            id="dialog-draggable-content"
            data-cy={dataCy}
        >
            <Text variant="h1" isInline={true}>
                {title}
            </Text>
            {!!onClose ? <DialogCloseIconButton onClick={onClose} /> : null}
        </MuiDialogTitle>
    );
};
